import React, { useCallback } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const AlreadyRegistered = ({ telegramLink }) => {
  const onTelegramClick = useCallback(() => {
    window.open(telegramLink, '_blank');
  }, [telegramLink]);

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <div className={styles.questionButton} onClick={() => window.open(telegramLink, '_blank')}>
        <p>Є питання?</p>
        <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.86207 0C0.837931 0 0 0.929593 0 2.06576V18.5919L2.7931 15.4932H20.4828C21.5069 15.4932 22.3448 14.5636 22.3448 13.4275V2.06576C22.3448 0.929593 21.5069 0 20.4828 0H1.86207ZM23.2759 8.26305V13.4275C23.2759 15.1833 22.0655 16.5261 20.4828 16.5261H13.0345V18.5919C13.0345 19.728 13.8724 20.6576 14.8966 20.6576H24.2069L27 23.7563V10.3288C27 9.19264 26.1621 8.26305 25.1379 8.26305H23.2759Z" fill="white" />
        </svg>
      </div>
      <p className={styles.title}>Супер!</p>
      <p className={styles.description}>
        Бачимо, що ти вже зареєстрований. Не гай часу, приєднуйся до Телеграму
        "Mr. Philip".
      </p>
      <img
        src={getImageFromS3('images/ua-hostess/result-sms-notifications.png')}
        alt="result-image"
        onClick={onTelegramClick}
      />
    </div>
  );
};

export default AlreadyRegistered;
